import { Modal } from 'react-bootstrap';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import UserStatuses from '../../UserStatus/UserStatuses';
import { UserStatusesModalStyled } from './styled/UserStatusesModalStyled';

function UserStatusesModal() {
    const { getLangPath } = useLangContext();

    return <>
        <Modal.Header closeButton>
            {getLangPath('user_statuses.title')}
        </Modal.Header>
        <UserStatusesModalStyled>
            <UserStatuses/>
        </UserStatusesModalStyled>
    </>;
}

export default UserStatusesModal;
